// src/features/interview/components/TimerDisplay.jsx
import React from "react";
import { Timer } from "lucide-react";

const TimerDisplay = ({ timeLeft, showTimer }) => {
  return (
    <div
      className={`
        fixed top-1 right-10
        flex items-center gap-2 m-2
        ${timeLeft <= 10 ? "animate-pulse" : ""}
        ${
          timeLeft <= 20
            ? "bg-red-500/10 border-2 border-red-500 text-red-500"
            : "bg-yellow-500/10 border-2 border-yellow-500 text-yellow-500"
        }
        px-4 py-2 rounded-full
        shadow-lg
        transition-all duration-300
        transform
        ${showTimer ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"}
      `}
    >
      <Timer className="w-5 h-5" />
      <span className="font-semibold">{timeLeft}s remaining</span>
    </div>
  );
};

export default TimerDisplay;
